import React from 'react';

import s from './InstructionItemContainer.module.scss';

type InstructionItemProps = {
  children: React.ReactNode;
};

/**
 * Враппер для карточки (задает паддинги и фон)
 * @param children
 * @constructor
 */
const InstructionItemContainer: React.FC<InstructionItemProps> = ({
  children,
}) => {
  return <div className={s['instruction-item-container']}>{children}</div>;
};

export default InstructionItemContainer;
